var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13749_13417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0524 7.6979L16.4435 5.07568C16.2711 4.90415 16.0378 4.80786 15.7946 4.80786C15.5514 4.80786 15.3181 4.90415 15.1457 5.07568L5.89683 14.3112L5.05238 17.9557C5.02325 18.0889 5.02425 18.227 5.0553 18.3597C5.08636 18.4925 5.14669 18.6167 5.23188 18.7232C5.31707 18.8297 5.42497 18.9158 5.5477 18.9752C5.67044 19.0347 5.8049 19.066 5.94127 19.0668C6.00481 19.0732 6.06884 19.0732 6.13238 19.0668L9.81683 18.2223L19.0524 8.99568C19.2239 8.82328 19.3202 8.58998 19.3202 8.34679C19.3202 8.1036 19.2239 7.8703 19.0524 7.6979ZM9.37238 17.4223L5.91905 18.1468L6.70572 14.7601L13.6257 7.86679L16.2924 10.5335L9.37238 17.4223ZM16.8879 9.88901L14.2213 7.22234L15.7679 5.68457L18.3902 8.35123L16.8879 9.88901Z",
    fill: "#209FED",
    stroke: "#209FED",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13749_13417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCircle);
export default __webpack_public_path__ + "static/media/edit-circle.f9ede7fce0ed7212697fb40f486efc34.svg";
export { ForwardRef as ReactComponent };